// ── ข้อมูลข่าว Cluster SIE ──
export const newsData = [
  {
    id: 1,
    title: 'บพท. ชี้ ธุรกิจชุมชนร่วม คือภูมิคุ้มกันและเป็นทางออก ของเศรษฐกิจไทย',
    date: '22 ก.ค. 2568',
    dateISO: '2025-07-22',
    youtube: 'https://youtu.be/-TT_VoQxqKc',
    youtubeId: '-TT_VoQxqKc',
    description: 'ดร.กิตติ สัจจาวัฒนา ผู้อำนวยการหน่วยบริหารและจัดการกองทุนด้านการพัฒนาระดับพื้นที่ (บพท.) กล่าวภายหลังตรวจเยี่ยมงาน นิทรรศการแสดงผลิตภัณฑ์ฮาลาล ของโครงการสร้างเครือข่ายธุรกิจชุมชนร่วม(Cluster) เพื่อพัฒนาเศรษฐกิจฐานราก ว่า ปัจจุบันความเสื่อมถอยของเศรษฐกิจ มาตรการการกีดกันทางการค้า มาตรการภาษี ทำให้การส่งออกนำเข้าสินค้าของประเทศไทยหยุดชะงัก มีการค้นพบว่าแหล่งที่จะสร้างงาน สร้างเศรษฐกิจ สร้างกรอบคุ้มภัยให้กับประเทศไทยที่ดีที่สุดคือ เศรษฐกิจชุมชน และเศรษฐกิจพื้นที่',
  },
  {
    id: 2,
    title: 'ฟันเฟืองคลัสเตอร์ SIE เปลี่ยนเศรษฐกิจฐานรากมั่นคง พลังชุมชนเปลี่ยนประเทศเข้มแข็ง',
    date: '1 ส.ค. 2568',
    dateISO: '2025-08-01',
    youtube: 'https://youtu.be/M5h8pbmeecs',
    youtubeId: 'M5h8pbmeecs',
    description: 'ฟันเฟืองคลัสเตอร์ SIE เปลี่ยนเศรษฐกิจฐานรากมั่นคง พลังชุมชนเปลี่ยนประเทศเข้มแข็ง',
  },
  {
    id: 3,
    title: 'บพท.หนุนสร้างเครือข่ายธุรกิจชุมชนร่วม Cluster ชุมชน วิจัยนวัตกรรมยกระดับเศรษฐกิจฐานราก สู่ตลาดสุขภาพ',
    date: '18 ส.ค. 2568',
    dateISO: '2025-08-18',
    youtube: 'https://youtu.be/OHXgoKxVKUI',
    youtubeId: 'OHXgoKxVKUI',
    description: 'ปัญหาเศรษฐกิจฐานรากของประเทศ สามารถส่งผลกระทบต่อความมั่นคงและความยั่งยืนของเศรษฐกิจชาติทั้งระบบ การที่หน่วยบริหารและจัดการกองทุนด้านการพัฒนาระดับพื้นที่ (บพท.) ให้การสนับสนุนกระบวนการศึกษาวิจัยของโครงการสร้างเครือข่ายธุรกิจชุมชนร่วม (Cluster) เพื่อพัฒนาเศรษฐกิจฐานราก ถือเป็นอีกลยุทธ์ที่สำคัญอย่างยิ่งในการพัฒนามิติเศรษฐกิจของประเทศ ให้ยั่งยืน',
  },
  {
    id: 4,
    title: 'ผักผลไม้ / กาแฟ — คลัสเตอร์ผลิตภัณฑ์กาแฟและผักผลไม้ ยกระดับเศรษฐกิจฐานราก',
    date: '28 ส.ค. 2568',
    dateISO: '2025-08-28',
    youtube: 'https://youtu.be/2vScOZ1lXhA',
    youtubeId: '2vScOZ1lXhA',
    description: 'บพท. ขับเคลื่อนเศรษฐกิจฐานราก ผ่านโครงการสร้างเครือข่ายธุรกิจชุมชนร่วม หรือคลัสเตอร์ โดยใช้ทรัพยากรและอัตลักษณ์ท้องถิ่น มาสร้างรายได้และยกระดับคุณภาพชีวิตประชาชน การรวมกลุ่มในรูปแบบ "คลัสเตอร์ผลิตภัณฑ์กาแฟ" กลายเป็นพลังสำคัญในการยกระดับเศรษฐกิจฐานราก',
  },
  {
    id: 5,
    title: 'ประมง / ฮาลาล — คลัสเตอร์ SIE เครือข่ายธุรกิจชุมชนร่วมภาคใต้',
    date: '9 ก.ย. 2568',
    dateISO: '2025-09-09',
    youtube: 'https://youtu.be/_pSm8Wpk-K0',
    youtubeId: '_pSm8Wpk-K0',
    description: 'คลัสเตอร์ SIE เครือข่ายธุรกิจชุมชนร่วมภาคใต้ นำเสนอศักยภาพงานวิจัยประมงและอาหารฮาลาล ที่เชื่อมโยงชุมชนกับตลาดโลก โดยเฉพาะการพัฒนาผลิตภัณฑ์จากประมงพื้นบ้านและอาหารฮาลาล พร้อมระบบ "อาหารฮาลาลฉุกเฉิน" ที่เก็บรักษาได้ยาวนานกว่า 1 ปี',
  },
  {
    id: 6,
    title: 'คลัสเตอร์ SIE เสริมพลังธุรกิจชุมชนไทย สอดรับมุมมองทูต เปิดประตูตลาดใหม่',
    date: '25 ก.ย. 2568',
    dateISO: '2025-09-25',
    youtube: 'https://youtu.be/ZJk9mx3HUUE',
    youtubeId: 'ZJk9mx3HUUE',
    description: 'อดีตท่านทูตมาเลเซีย และอดีตท่านทูตตะวันออกกลาง ร่วมพูดคุยกับคลัสเตอร์ SIE เสริมพลังธุรกิจชุมชนไทย เปิดประตูตลาดใหม่',
  },
  {
    id: 7,
    title: 'สวส. จัดงาน "Social Enterprise Ecosystem Forum 2025" มอบนโยบายใหม่ เสริมพลังวิสาหกิจเพื่อสังคม',
    date: '16 ก.ย. 2568',
    dateISO: '2025-09-16',
    youtube: 'https://youtu.be/r0KSTIDL3PA',
    youtubeId: 'r0KSTIDL3PA',
    description: 'สวส. จัดงาน Social Enterprise Ecosystem Forum 2025 มอบนโยบายใหม่ เสริมพลังวิสาหกิจเพื่อสังคม',
  },
  {
    id: 8,
    title: 'สวส. หนุน SE รวมพลังวิสาหกิจเพื่อสังคม สู่อนาคตไทยยั่งยืน',
    date: '22 ก.ย. 2568',
    dateISO: '2025-09-22',
    youtube: 'https://youtu.be/dXPumxLkAEc',
    youtubeId: 'dXPumxLkAEc',
    description: 'สำนักงานส่งเสริมวิสาหกิจเพื่อสังคม หรือ สวส. จัดประชุมสมัชชาวิสาหกิจเพื่อสังคม ประจำปี 2568 ภายใต้แนวคิด "Driving Sustainable Impact Together" ร่วมผลักดันการทำงานของ SE สู่ผลลัพธ์ทางสังคมที่ยั่งยืน',
  },
  {
    id: 9,
    title: 'พลังคลัสเตอร์ไทย เชื่อมทูตการค้า เปิดประตูตลาดโลก ยกระดับเศรษฐกิจฐานราก',
    date: '27 ม.ค. 2569',
    dateISO: '2026-01-27',
    youtube: 'https://youtu.be/oF2Cwu7j7-Q',
    youtubeId: 'oF2Cwu7j7-Q',
    description: 'พลังคลัสเตอร์ไทย เชื่อมทูตการค้า เปิดประตูตลาดโลก ยกระดับเศรษฐกิจฐานราก ในรายการ คนหลังข่าว TNN 16',
  },
  {
    id: 10,
    title: 'ทอล์ก : ดร.กิตติ สัจจาวัฒนา ผอ.บพท. — ยุทธศาสตร์แก้ปัญหายากจน สร้างโอกาส ทางรอดเศรษฐกิจไทยสู่ฐานราก',
    date: '18 ส.ค. 2568',
    dateISO: '2025-08-18',
    youtube: 'https://youtu.be/AeJ5yVSikWU',
    youtubeId: 'AeJ5yVSikWU',
    description: 'บพท. ยุทธศาสตร์แก้ปัญหายากจน สร้างโอกาส ทางรอดเศรษฐกิจไทยสู่ฐานราก เพิ่มศักยภาพแข่งขันสู่เวทีตลาดโลก',
  },
]
